import { ChevronDown, ChevronRight, Plus } from 'lucide-react';
import type { FlatNode } from './timelineUtils';
import { ROW_HEIGHT } from './timelineUtils';
import { resolveIssueTypeConfig } from '../../../constants/issueTypeConfig';
export { ISSUE_TYPE_CONFIG } from '../../../constants/issueTypeConfig';

/**
 * Child issue types allowed per parent type.
 * @deprecated CHG-052: 동적 계층 규칙에서는 API의 allowedChildTypes 사용.
 *   API 데이터가 없는 경우 폴백으로 유지.
 */
export const CHILD_TYPES: Record<string, { value: string; label: string }[]> = {
  EPIC: [
    { value: 'STORY', label: '스토리' },
    { value: 'BUG', label: '버그' },
  ],
  Epic: [
    { value: 'Story', label: '스토리' },
    { value: 'Bug', label: '버그' },
  ],
  STORY: [
    { value: 'TASK', label: '작업' },
    { value: 'BUG', label: '버그' },
  ],
  Story: [
    { value: 'Task', label: '작업' },
    { value: 'Bug', label: '버그' },
  ],
  TASK: [
    { value: 'SUB_TASK', label: '하위작업' },
    { value: 'BUG', label: '버그' },
  ],
  Task: [
    { value: 'Subtask', label: '하위작업' },
    { value: 'Bug', label: '버그' },
  ],
};

interface Props {
  node: FlatNode;
  isExpanded: boolean;
  onToggle: () => void;
  onClick: () => void;
  onAddChild?: () => void;
}

export default function IssueTreeItem({ node, isExpanded, onToggle, onClick, onAddChild }: Props) {
  const config = resolveIssueTypeConfig(node.issueTypeDef, node.issueType);
  const { Icon } = config;
  const hasNoDate = !node.startDate && !node.dueDate;

  return (
    <div
      className={`group/item flex items-center gap-1.5 pr-2 cursor-pointer hover:bg-gray-50 border-b border-gray-100 select-none ${
        hasNoDate ? 'text-gray-400' : ''
      }`}
      style={{ paddingLeft: `${node.depth * 20 + 8}px`, height: `${ROW_HEIGHT}px` }}
      onClick={onClick}
    >
      {node.hasChildren ? (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onToggle();
          }}
          className="w-4 h-4 flex items-center justify-center flex-shrink-0 text-gray-400 hover:text-gray-600"
        >
          {isExpanded ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
        </button>
      ) : (
        <span className="w-4 flex-shrink-0" />
      )}
      <Icon size={14} className={`flex-shrink-0 ${config.color}`} style={config.hexColor ? { color: config.hexColor } : undefined} />
      {node.issueType !== 'GROUP' && (
        <span className="text-sm text-gray-400 flex-shrink-0 font-mono">{node.issueId}</span>
      )}
      <span className="text-sm truncate flex-1">{node.title}</span>
      {onAddChild && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onAddChild();
          }}
          className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-gray-300 hover:text-blue-500 hover:bg-blue-50 rounded opacity-0 group-hover/item:opacity-100 transition-opacity"
          title="하위 작업 추가"
        >
          <Plus size={14} />
        </button>
      )}
    </div>
  );
}
